<template>
  <div>
    <b-form @submit="onSubmit" @reset="onReset" class="container">
      <div class="row">
        <b-form-group
          class="col-md-12"
          id="input-group-1"
          label="Phone Number:"
          label-for="input-1"
          description="We'll send you a text to confirm your purchase. This number must match our records."
        >
          <b-form-input
            id="input-1"
            v-model="form.phone"
            type="text"
            v-mask="'1-(###)-###-####'"
            v-on:input="verify_phone_number()"
            required
            placeholder="Enter Phone Number"
          ></b-form-input>
          <b-alert
            v-model="form.alerts.phone.show"
            variant="danger"
            dismissible
          >{{ form.alerts.phone.message }}</b-alert>
        </b-form-group>
        <b-form-group
          class="col-lg-7 col-md-6 col-sm-12"
          id="input-group-2"
          label="Card Number:"
          label-for="input-2"
        >
          <b-input-group>
            <b-form-input
              id="input-card-number"
              v-model="form.cardNumber"
              :type="form.type"
              v-mask="'####.####.####'"
              v-on:input="verify_account_number()"
              required
              placeholder="Enter Card Number"
            ></b-form-input>
            <b-input-group-append>
              <b-button v-on:click="show_hide_clicked" variant="info">{{show_hide}}</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-col style="padding-left: 0">
            If you do not have an account you can apply <a href="https://apply.rispos.com">here</a>
          </b-col>
          <b-alert
            v-model="form.alerts.accountNumber.show"
            variant="danger"
            dismissible
          >{{ form.alerts.accountNumber.message }}</b-alert>
        </b-form-group>
      </div>
      <b-alert v-model="showError" variant="danger" dismissible>{{ errorMessage }}</b-alert>
      <b-button class="btn btn-small btn-primary" type="submit" variant="primary">Submit</b-button>
    </b-form>
  </div>
</template>


<script>
export default {
  data() {
    return {
      showError: false,
      order_id: "",
      errorMessage: "",
      form: {
        cardNumber: "",
        phone: "",
        type: "password",
        alerts: {
          accountNumber: {
            show: false
          },
          phone: {
            show: false
          }
        }
      },
      show_hide: "Show"
    };
  },
  methods: {
    verify_phone_number() {
      if (this.form.phone.length !== 16) {
        this.form.alerts.phone.message = "Please enter a valid phone number";
        this.form.alerts.phone.show = true;
        return false;
      }
      this.form.alerts.phone.message = "";
      this.form.alerts.phone.show = false;
      return true;
    },
    verify_account_number() {
      if (this.form.cardNumber.length !== 14) {
        this.form.alerts.accountNumber.message =
          "Please enter your full 12 digit account number";
        this.form.alerts.accountNumber.show = true;
        return false;
      }
      this.form.alerts.accountNumber.message = "";
      this.form.alerts.accountNumber.show = false;
      return true;
    },
    // verify_zip() {
    //   if (this.form.zipCode.length !== 5) {
    //     this.form.alerts.zipCode.message = "Please enter a valid zip code";
    //     this.form.alerts.zipCode.show = true;
    //     return false;
    //   }
    //   this.form.alerts.zipCode.message = "";
    //   this.form.alerts.zipCode.show = false;
    //   return true;
    // },
    show_hide_clicked() {
      if (this.show_hide === "Hide") {
        this.form.type = "password";
        this.show_hide = "Show";
      } else {
        this.form.type = "text";
        this.show_hide = "Hide";
      }
    },
    onSubmit(evt) {
      let self = this;
      evt.preventDefault();
      if (
        this.verify_phone_number() &&
        this.verify_account_number()
        // this.verify_zip()
      ) {
        this.axios
          .post("https://apps.retailcreditcloudapi.net/api/web/transaction", {
            order_id: this.order_id,
            accountNumber: this.form.cardNumber.replace(/\.*/g, ""),
            phone: this.form.phone.replace(/[-()]*/g, "").substr(1),
            origin: 'bigcommerce'
          })
          .then(
            function() {
              self.$emit("complete-purchase");
            },
            function() {
              self.showError = true;
              self.errorMessage =
                "We could not complete your purchase. Please confirm your information is correct.";
              // self.errorMessage = error.message;
            }
          );
      }
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
    }
    // setZip(zip) {
    //   this.form.zipCode = zip;
    // }
  },
  beforeMount() {
    let self = this;
    this.order_id = new URLSearchParams(window.location.search).get("orderid");
    // this.axios
    //   .get("https://apps.retailcreditcloudapi.net/api/web/zip", {
    //     params: {
    //       order_id: this.order_id
    //     }
    //   })
    //   .then(function(response) {
    //     self.setZip(response.data.zip);
    //   });
    // .catch(function (error) {
    //     currentObj.output = error;
    // });
  }
};
</script>
<style>
.alert {
  margin-top: 5px;
}
</style>
